<template>
  <div class="upfile">
    <ImgCutter v-on:cutDown="cutDown"
               :cutWidth="cutOption.width"
               :cutHeight="cutOption.height">
      <div slot="open"
           class="avatar-uploader">
        <div tabindex="0"
             class="el-upload el-upload--text">
          <!--  @click="up" -->
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <img :src="value"
               alt=""
               width="100%"
               height="100%"
               v-if="value" />
        </div>
      </div>
    </ImgCutter>

  </div>
</template>

<script>
import ImgCutter from '@/components/ImgCutter'
export default {
  components: {
    ImgCutter
  },
  props: {
    value: {
      type: String
    },
    cutOption: {
      type: Object,
      default () {
        return {
          width: 240,
          height: 240
        }
      }
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  data () {
    return {
      uploadUrl: this.$http.adornUrl(
        window.SITE_CONFIG.contextPath + '/zuul' + '/p/file/uploadFile'
      )
    }
  },
  computed: {},
  created () { },
  mounted () { },
  watch: {},
  methods: {
    cutDown (file) {
      console.log(file.file)
      this.up(file.file)
    },
    up (file) {
      let data = new FormData()
      data.append('file', file)
      this.$http({
        url: this.uploadUrl,
        method: 'post',
        data
      }).then((res) => {
        if (res.data.code === 'C0000') {
          this.$message.success('上传成功')
          this.$emit('change', res.data.result)
        } else {
          this.$message.error(res.data.message)
          this.loading = false
        }
      })
      // let input = document.createElement('input')
      // input.type = 'file'
      // input.click()
      // input.onchange = () => {
      //   let file = input.files[0]
      //   let data = new FormData()
      //   data.append('file', file)
      //   this.$http({
      //     url: this.uploadUrl,
      //     method: 'post',
      //     data
      //   }).then((res) => {
      //     if (res.data.code === 'C0000') {
      //       this.$message.success('上传成功')
      //       this.$emit('change', res.data.result)
      //     } else {
      //       this.$message.error(res.data.message)
      //       this.loading = false
      //     }
      //   })
      // }
    }
  }
}
</script>

<style lang="scss" scope>
.upfile {
  display: inline-block;
  .avatar-uploader .avatar-uploader-icon {
    width: 180px;
    height: 180px;
    line-height: 180px;
    position: relative;
  }
  .image {
    display: inline-block;
    width: 50px;
    height: 50px;
    margin-left: 10px;
  }
  img {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
  }
}
.upfile .avatar-uploader .avatar-uploader-icon {
  width: 80px;
  height: 80px;
  line-height: 80px;
}
.upfile img {
  width: 80px;
  height: 80px;
}
.avatar-uploader .el-upload {
  width: 80px;
  height: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upfile2.vue